
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registreren",
      function () {
        return require("private-next-pages/registreren/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registreren"])
      });
    }
  